import React, { useState, useContext } from 'react'
import { Button } from 'antd'
import { BellOutlined, MailOutlined } from '@ant-design/icons'
import NotificationsContext from 'context/Notifications/NotificationsContext'
import { ALARMS, NOTIFICATIONS } from 'context/Notifications/constants'
import { StyledBadge } from './styled'
import Drawer from './components/Drawer'

const NotificationCenter = () => {
  const {
    generalNotifications = [],
    activeAlarms = [],
    groupedReplies = {}
  } = useContext(NotificationsContext)

  const [visible, setVisible] = useState(false)

  const onClose = () => setVisible(false)
  const onOpen = menu => {
    setVisible(menu)
  }

  const count = generalNotifications.length + Object.keys(groupedReplies).length

  return (
    <>
      <Button
        padding="4px 15px"
        margin="0 0 0 15px"
        onClick={() => onOpen(ALARMS)}
        type="link"
        data-test="notificationCenterAlarmsBtn"
      >
        <StyledBadge count={activeAlarms.length}>
          <BellOutlined style={{ fontSize: 16 }} />
        </StyledBadge>
      </Button>
      <Button
        padding="4px 15px"
        margin="0 0 0 15px"
        onClick={() => onOpen(NOTIFICATIONS)}
        type="link"
        data-test="notificationCenterNotificationsBtn"
      >
        <StyledBadge count={count}>
          <MailOutlined style={{ fontSize: 16 }} />
        </StyledBadge>
      </Button>
      {!!visible && (
        <Drawer
          visible={visible}
          onClose={onClose}
          generalNotifications={generalNotifications}
          alarms={activeAlarms}
          groupedReplies={groupedReplies}
        />
      )}
    </>
  )
}

export default NotificationCenter
